import "./FooterStyle.css";
export default function Footer() {
  return (
    <div className='footer-root'>
      <div className='footer-div'>
        <div className='footer-left-div'>Copyright &copy; 2023</div>
        <div className='footer-right-div'>Made with ❤️ by Kanika</div>
      </div>
    </div>
  );
}
